import { render, staticRenderFns } from "./TableFacility.vue?vue&type=template&id=ca1337b6"
import script from "./TableFacility.vue?vue&type=script&lang=js"
export * from "./TableFacility.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports